export const FOLD_TIMES_AFTER = 5;
